module.exports = __webpack_public_path__ + "static/img/Storm.89c6f83.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Storm.svg
// module id = z7zh
// module chunks = 1